import { render } from "./agenda.vue?vue&type=template&id=13be527b&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=13be527b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13be527b"

export default script